import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    grade_level: '',
    subject: '',
  },
  goalbankFilters: null,
  goalbankSelection: {},
  curriculumSelection: {}
}

export const domainsUI = createSlice({
  name: 'domainsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setGoalbankFilters: (state, { payload }) => {
      state.goalbankFilters = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setSubject,
  setGradeLevel,
  setGoalbankFilters,
  trackActiveFilters,
  clearAllFilters,
} = domainsUI.actions

export default domainsUI.reducer
